export const SIDEBAR_WIDTH = 49;

export const DEFAULT_FIELD_GAP = "10px";

export const MAX_ACTION_FIELD_WIDTH = "550px";
export const DEFAULT_LABEL_WIDTH = "80px";
export const LIST_TABLE_BUTTON_HEIGHT = "28px";
export const TOP_RIGHT_BUTTON_HEIGHT = "32px";

export const DISPLAY_INFO_LABEL_PROPS = {
  fontSize: "sm",
};

export const DISPLAY_INFO_VALUE_PROPS = {
  fontSize: "md",
};

export const FLUSHED_BORDER_BASE = {
  border: "none",
  borderBottom: "1px solid",
  borderColor: "inherit",
  borderRadius: "0",
};

export const FLUSHED_ACTIVE_BOTTOM_BORDER = {
  borderBottom: "2px solid var(--chakra-colors-brand-500)",
};

export const FLUSHED_ERROR_BOTTOM_BORDER = {
  borderBottom: "2px solid var(--chakra-colors-error-500)",
};

const FLUSHED_FLOATING_FOCUS = {
  ...FLUSHED_ACTIVE_BOTTOM_BORDER,
  boxShadow: "0px 1px 0px 0px var(--chakra-colors-brand-500)",
};

// Reusable sx for any input/textarea inside a FloatingField.
// Applies the bottom border, brand-500 focus ring, and hides placeholder text
// (FloatingField inputs use placeholder=" " for the :placeholder-shown CSS trick).
export const FLUSHED_FLOATING_INPUT_SX = {
  ...FLUSHED_BORDER_BASE,
  _focus: FLUSHED_FLOATING_FOCUS,
  _focusVisible: FLUSHED_FLOATING_FOCUS,
  _placeholder: { color: "transparent" },
};

export const floatingNoValueBorder = {
  borderBottomColor: "var(--chakra-colors-gray-200)",
  borderWidth: "2px",
  boxShadow: "none",
};

export const importantFloatingNoValueBorder = {
  border: "2px solid var(--chakra-colors-gray-200) !important",
  boxShadow: "none !important",
};

export const selectedInputBorder = {
  borderColor: "var(--chakra-colors-brand-500)",
  borderWidth: "2px",
  boxShadow: "0px 0px 10px 0px #BCECFD",
};

export const importantSelectedInputBorder = {
  border: "2px solid var(--chakra-colors-brand-500) !important",
  boxShadow: "0px 0px 10px 0px #BCECFD !important",
};

export const formInputWithValueBorder = {
  borderColor: "var(--chakra-colors-hasValueBorder-DEFAULT)",
  borderWidth: "2px",
  boxShadow: "none",
};

export const importantFormInputWithValueBorder = {
  border: "2px solid var(--chakra-colors-hasValueBorder-DEFAULT) !important",
  boxShadow: "none !important",
};
